import React, { useCallback, useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import { connect } from 'react-redux';
import { Input } from 'reactstrap'
import Label from "reactstrap/lib/Label";
import UserDucks from 'stores/ducks/User.duck';
import {
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from 'reactstrap';
import Error from 'components/alerts/Error';
import { NumberInput } from 'components/common/form/modules/input/Number';
import { Text } from 'components/common/form/modules/input/Text';
import { TextArea } from 'components/common/form/modules/input/TextArea';
import { Info } from 'components/common/form/modules/Info';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { createInventoryItem, isPaymentSetup, shareInventoryItems } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import MultiSelect from "@khanacademy/react-multi-select";
import { ResponsiveScatterPlot } from '@nivo/scatterplot'

const CreateInventoryModal: React.FC<{ [label: string]: any }> = (props: any) => {

    if (props.user.id === '') {
        return null;
    }

    const today = new Date()
    const now = new Date()
    const zero = new Date()

    now.setHours(23)
    now.setMinutes(45)
    zero.setHours(0);
    zero.setMinutes(0);

    let flag1 = false;
    let flag2 = false;

    const [campaignId] = useState(props.campaignId)

    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const [name, setName] = useState('')
    const [price, setPrice] = useState(0)
    const [basePrice] = useState(0)
    const [slashedPrice, setSlashedPrice] = useState(undefined)
    const [quantity, setQuantity] = useState(0)
    const [description, setDescription] = useState('')
    const [autoSale, setAutoSell] = useState(false)

    const op = props.currentAffiliates
    const tempOptions: any[] = [{
        label: 'My Primary Link',
        value: props.user.isAdmin ? props.createdBy : props.user.id
    }]
    if (op) {
        op.map((item: any) => {
            tempOptions.push({
                label: item.username.includes("-additional-link-") ?
                    (item.username.split("-")[0] + " (link #" + (Number(item.username.split("-")[3]) + 2).toString() + ")") : item.username.toLowerCase().trim(),
                value: item.email.toLowerCase().trim()
            })
        })
    }

    const [options] = useState<any[]>(tempOptions)
    const [selected, setSelected] = useState<any[]>(props.email && props.email !== '' ? [] : [
        props.user.isAdmin ? props.createdBy : props.user.id
    ])
    const [imageHeight, setImageHeight] = useState(0)

    const onImgLoad = useCallback(({ target: img }) => {
        setImageHeight(img.offsetHeight)
    }, [setImageHeight])

    const [startTime, setStartTime] = useState(new Date())
    const [endTime, setEndTime] = useState(
        new Date(
            props.endTime.year,
            props.endTime.month - 1,
            props.endTime.day,
            (props.endTime.PM ? props.endTime.hour + 12 : props.endTime.hour),
            props.endTime.minute
        )
    )

    const [height] = useState(props.floorplan ? props.floorplan.height : 10)
    const [width] = useState(props.floorplan ? props.floorplan.width : 10)
    const [labels] = useState(props.floorplan ? props.floorplan.labels : [])
    const [inventoryMap] = useState(props.floorplan ? props.floorplan.inventoryMap : [])
    const [data, setData] = useState([])
    const [spots, setSpots] = useState([])
    const [assignSpot, setAssignSpot] = useState(false)
    const [bid, setBid] = useState(false)

    const [hasOwnerSetupPayments, setHasOwnerSetupPayments] = useState(false)

    const [sellAfter, setSellAfter] = useState('')
    const [selectedName, setSelectedName] = useState('')

    const [btnDisabled, setBtnDisabled] = React.useState(false)
    const [createBtnText, setCreateBtnText] = React.useState('CREATE')


    useEffect(() => {
        // isPaymentSetup
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: isPaymentSetup,
                variables: {
                    id: props.createdBy
                }
            })
            .then(res => {
                if (res.data.data.user.isPaymentSetup === true) {
                    setHasOwnerSetupPayments(true)
                }
            })

        if (props.floorplan) {
            const initData: any = [];
            initData.push({
                id: 'Available',
                data: []
            })
            for (let m = 0; m < width; m++) {
                for (let n = 0; n < height; n++) {
                    const node1 = labels.find((item: any) => {
                        return item.x === m && item.y === n
                    })
                    const node2 = inventoryMap.find((item: any) => {
                        return item.x === m && item.y === n
                    })
                    if (node1 === undefined && node2 === undefined) {
                        initData[0].data.push({
                            x: m, y: n
                        })
                    }
                }
            }
            labels.map((item: any) => {
                initData.push({
                    id: item.label,
                    data: [{ x: item.x, y: item.y }]
                })
            })
            const allocatedInventory: any[] = [];
            inventoryMap.map((item: any) => {
                allocatedInventory.push({ x: item.x, y: item.y })
            })
            initData.push({
                id: 'Unavailable',
                data: allocatedInventory
            })
            if (assignSpot) {
                initData.push({
                    id: name,
                    data: spots
                })
            }
            setData(initData)
        }
    }, [setData, height, width, labels, spots, assignSpot, name, inventoryMap, setHasOwnerSetupPayments, props.createdBy])

    const handleStartChange = useCallback((e) => {
        if (e > endTime) {
            setStartTime(e)
            setEndTime(e)
        } else {
            if (bid) {
                const sevenDaysStart = new Date(endTime.getTime())
                sevenDaysStart.setDate((sevenDaysStart.getDate() - 7))

                const updatedEndTime = new Date(e.getTime())
                updatedEndTime.setDate(updatedEndTime.getDate() + 7)

                if (e > sevenDaysStart) {
                    setStartTime(e)
                } else {
                    setStartTime(e)
                    setEndTime(updatedEndTime)
                }
            } else {
                setStartTime(e)
            }
        }
    }, [endTime, setStartTime, setEndTime, bid])

    const handleEndChange = useCallback((e) => {
        if (e < startTime) {
            setStartTime(e)
            setEndTime(e)
        } else {

            if (bid) {
                const sevenDaysEnd = new Date(startTime.getTime())
                sevenDaysEnd.setDate((sevenDaysEnd.getDate() + 7))

                const updatedStartDate = new Date(e.getTime())
                updatedStartDate.setDate(updatedStartDate.getDate() - 7)

                if (e < sevenDaysEnd) {
                    setEndTime(e)
                } else {
                    setEndTime(e)
                    setStartTime(updatedStartDate)
                }
            } else {
                setEndTime(e)
            }
        }
    }, [startTime, setStartTime, setEndTime, bid])

    if (startTime.getFullYear() === today.getFullYear()) {
        if (startTime.getMonth() === today.getMonth()) {
            if (startTime.getDate() === today.getDate()) {
                flag1 = true;
            }
        }
    }
    if (endTime.getFullYear() === today.getFullYear()) {
        if (endTime.getMonth() === today.getMonth()) {
            if (endTime.getDate() === today.getDate()) {
                flag2 = true;
            }
        }
    }

    const resetCreateBtnText = () => {
        setBtnDisabled(false)
        setCreateBtnText('CREATE')
    }

    const handleCreateInventory = useCallback(() => {

        setError(false)
        setErrorMessage('')

        if (name.trim() === '') {
            setError(true)
            return alert('Name is required')
        }

        if (Number.isNaN(Number(quantity)) || Number(quantity) % 1 !== 0) {
            setError(true)
            return alert('Quantity should be a whole number')
        }

        if (Number.isNaN(Number(price))) {
            setError(true)
            return alert('Price should be a number. No alphabets/symbols. (Decimal allowed.)')
        }

        if (slashedPrice) {
            if (Number.isNaN(Number(slashedPrice))) {
                setError(true)
                return alert('Slashed price should be a number. No alphabets/symbols. (Decimal allowed.)')
            } else if (Number(slashedPrice) < 0) {
                setError(true)
                return alert('Slashed Price is invalid')
            }
        }

        if (Number(price) < 0) {
            setError(true)
            return alert('Price is invalid')
        }

        if (bid) {
            if (Number(price) < 1) {
                setError(true)
                return alert('Minimum bid amount is $1')
            }
        }

        if (Number(basePrice) < 0) {
            setError(true)
            return alert('Trade price is invalid')
        }

        if (Number(quantity) < 0) {
            setError(true)
            return alert('Quantity is invalid')
        }

        const bidStartDate = new Date(
            endTime.getFullYear(),
            endTime.getMonth(),
            endTime.getDate(),
            endTime.getHours(),
            endTime.getMinutes()
        )
        bidStartDate.setDate(bidStartDate.getDate() - 7)

        const isPrimaryLinkIn = selected.findIndex((i: any) => {
            return i === (props.user.isAdmin ? props.createdBy : props.user.id)
        })
        const forSomeoneElse = (isPrimaryLinkIn === -1) ? true : false

        setBtnDisabled(true)
        setCreateBtnText('CREATING...')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: createInventoryItem,
                variables: {
                    inventoryItem: {
                        name,
                        price: Number(price),
                        slashedPrice: slashedPrice ? Number(slashedPrice) : undefined,
                        basePrice: Number(basePrice),
                        quantity: Number(quantity),
                        description,
                        campaignId,
                        autoSale,
                        startTime: bid || autoSale ? {
                            year: startTime.getFullYear(),
                            month: startTime.getMonth() + 1,
                            day: startTime.getDate(),
                            hour: startTime.getHours() > 12 ? startTime.getHours() - 12 : startTime.getHours(),
                            minute: startTime.getMinutes(),
                            PM: startTime.getHours() > 12 ? true : false
                        } : null,
                        endTime: bid || autoSale ? {
                            year: endTime.getFullYear(),
                            month: endTime.getMonth() + 1,
                            day: endTime.getDate(),
                            hour: endTime.getHours() > 12 ? endTime.getHours() - 12 : endTime.getHours(),
                            minute: endTime.getMinutes(),
                            PM: endTime.getHours() > 12 ? true : false
                        } : null,
                        spots: assignSpot ? spots : [],
                        sellAfter: sellAfter === '' ? null : sellAfter,
                        forSomeoneElse
                    },
                    sellerId: props.user.isAdmin ? props.createdBy : props.user.id,
                    bid,
                }
            })
            .then(res => {
                if (
                    res.data.data.inventoryItem.create
                    && res.data.data.inventoryItem.create !== ''
                    && (!props.email || props.email === '')
                ) {
                    if (props.currentAffiliates) {
                        const shareWith: any[] = []
                        selected.map((i: any) => {
                            if (i !== (props.user.isAdmin ? props.createdBy : props.user.id)) {
                                shareWith.push(i)
                            }
                        })
                        if (shareWith.length !== 0) {
                            fetchAPI
                                .post(API_ENDPOINTS.BASE_URL, {
                                    query: shareInventoryItems,
                                    variables: {
                                        campaignId,
                                        userId: props.user.isAdmin || props.isHost ? props.createdBy : props.user.id,
                                        usernamesAndEmailsArray: shareWith,
                                        inventoryItems: [{
                                            inventoryItemId: res.data.data.inventoryItem.create,
                                            quantity: Number(quantity),
                                            commission: 0,
                                            commissionRate: 0
                                            // defaults to 0 commission
                                        }]
                                    }
                                })
                                .then(r => {
                                    if (r.data.data.inventoryItem.shareInventory) {
                                        props.reloadData()
                                        closeModal()
                                    } else {
                                        alert('An unknown error occurred, try again')
                                        setError(true)
                                        resetCreateBtnText()
                                    }
                                })
                                .catch(err => {
                                    console.log(err)
                                    alert('An unknown error occurred, try again')
                                    resetCreateBtnText()
                                })
                        } else {
                            props.reloadData();
                            closeModal()
                        }
                    } else {
                        props.reloadData();
                        closeModal()
                    }
                } else {
                    alert('Unknown error occurred, try again')
                    setError(true)
                    resetCreateBtnText()
                }
            })
            .catch(err => {
                console.log(err)
                alert('An unknown error occurred, try again')
                resetCreateBtnText()
            })
    }, [campaignId, setError, setErrorMessage, name, price, slashedPrice,
        quantity, description, basePrice, props.user,
        spots, assignSpot, sellAfter, selected,
        props.createdBy, autoSale, startTime, endTime, bid])

    const nodeOnClick = useCallback((n, e) => {
        const label = labels.find((item: any) => {
            return item.x === n.data.x && item.y === n.data.y
        })
        const mapItem = inventoryMap.find((item: any) => {
            return item.x === n.data.x && item.y === n.data.y
        })
        const index = spots.findIndex((item: any) => {
            return item.x === n.data.x && item.y === n.data.y
        });
        if (index === -1) {
            if (!label && !mapItem) {
                const updatedSpots = JSON.parse(JSON.stringify(spots))
                updatedSpots.push({
                    x: n.data.x, y: n.data.y, bought: false
                })
                setSpots(updatedSpots)
                setQuantity(updatedSpots.length)
            }
        } else {
            const updatedSpots = JSON.parse(JSON.stringify(spots))
            updatedSpots.splice(index, 1)
            setSpots(updatedSpots)
            setQuantity(updatedSpots.length)
        }

    }, [spots, setSpots, labels, inventoryMap, setQuantity])

    const CustomNode = useCallback(({
        node,
        x,
        y,
        size,
        color,
        blendMode,
        onMouseEnter,
        onMouseMove,
        onMouseLeave,
        onClick,
    }) => {
        const label = props.floorplan ? props.floorplan.labels.find((i: any) => {
            return i.label.toString().trim() === node.data.serieId.toString().trim()
        }) : null
        if (!label) {
            return (
                <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                    <circle
                        stroke={node.data.serieId === 'Available' ? "#242d51" : '#f1f1f1'}
                        stroke-width="0.5"
                        fill-opacity={node.data.serieId === 'Available' || node.data.serieId === 'Unavailable' ? 0.4 : 1}
                        stroke-opacity={0.75}
                        r={size * 0.5}
                        fill={node.data.serieId === 'Available' ? '#f1f1f1' :
                            node.data.serieId === 'Unavailable' ? '#242d51' : '#d63191'}
                        style={{ mixBlendMode: blendMode, zIndex: 15000000, opacity: 1 }}
                        onMouseEnter={onMouseEnter}
                        onMouseMove={onMouseMove}
                        onMouseLeave={onMouseLeave}
                        onClick={onClick}
                    />
                </g>
            )
        }
        return (
            <g transform={`translate(${x},${y})`} style={{ zIndex: 15000000, opacity: 1 }}>
                <text
                    x={size * -1}
                    y={size * 0.5}
                    font-size='8px'
                    font-style='bold'
                    color='#1931b9'
                    font-color='#1931b9'
                    style={{ zIndex: 150, opacity: 1 }}
                >
                    {label.label.toUpperCase()}
                </text>
            </g>
        )
    }, [props.floorplan])

    return <div style={{ padding: '20px' }}>
        <div style={{ marginBottom: 4 }}>
            <Text
                label='Name *'
                value={name}
                onChange={e => setName(e.target.value)}
                required={true}
            />
        </div>
        <div style={{ marginBottom: 4 }}>
            <TextArea
                label='Description'
                value={description}
                onChange={e => {
                    if (e.target.value.length > 200) {
                        setDescription(e.target.value.substring(0, 200))
                    } else {
                        setDescription(e.target.value)
                    }
                }}
                placeholder={'(Optional)'}
                infoMessage={((200 - description.length).toString() + ' characters left')}
            />
        </div>
        {
            assignSpot ? null :
                <NumberInput
                    label='Qty *'
                    value={quantity}
                    onChange={e => setQuantity(e.target.value)}
                    required={true}
                />
        }
        {
            hasOwnerSetupPayments ?
                <div style={{ marginTop: 4 }}>
                    <NumberInput
                        label={bid ? 'Minimum Bid $ *' : 'Price $ *'}
                        value={price}
                        min={0}
                        onChange={e => setPrice(e.target.value)}
                        required={true}
                    />
                    <Info>
                        Enter numeric value.
                    </Info>
                </div>
                : <div>
                    <h6>
                        Price $0
                    </h6>
                    <p style={{ fontSize: '10px' }}>
                        Campaign owner has not set up payments yet.
                    </p>
                </div>
        }
        {
            hasOwnerSetupPayments ?
                <div style={{ marginTop: 4 }}>
                    <NumberInput
                        label='Slashed Price'
                        value={slashedPrice}
                        min={0}
                        max={price}
                        onChange={e => setSlashedPrice(e.target.value)}
                        required={false}
                    />
                    <Info>
                        Enter numeric value.
                    </Info>
                </div>
                : <div>
                    <h6>
                        Slashed Price $0
                    </h6>
                    <p style={{ fontSize: '10px' }}>
                        Campaign owner has not set up payments yet.
                    </p>
                </div>
        }
        {
            !bid ?
                <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                    <br />
                    <Input
                        type="checkbox"
                        checked={autoSale}
                        onChange={e => setAutoSell(!autoSale)}
                        style={{ height: 'auto' }}
                    />
                    <span style={{ paddingLeft: '5px' }}>
                        Customise Sales Time
                    </span>
                </div> : null
        }
        {
            autoSale || bid ?
                <div style={{ textAlign: 'left', paddingTop: '20px' }}>
                    <div>
                        <div style={{ width: '100%' }}>
                            <p>Start</p>
                            <DatePicker
                                selected={startTime}
                                onChange={handleStartChange}
                                selectsStart={true}
                                startDate={startTime}
                                endDate={endTime}
                                minDate={new Date()}
                                minTime={flag1 ? new Date() : zero}
                                maxTime={now}
                                showTimeSelect={true}
                                timeFormat="HH:mm"
                                timeIntervals={15}
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeCaption="time"
                                style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}

                            />
                        </div>
                        <p />
                    </div>
                    <div style={{ width: '100%' }}>
                        <p>End</p>
                        <DatePicker
                            selected={endTime}
                            onChange={handleEndChange}
                            selectsEnd={true}
                            startDate={startTime}
                            endDate={endTime}
                            minDate={startTime}
                            minTime={flag2 ? new Date() : zero}
                            maxTime={now}
                            showTimeSelect={true}
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="MMMM d, yyyy h:mm aa"
                            timeCaption="time"
                            style={{ width: '100%', border: 'none', backgroundColor: '#ebecf1' }}
                        />
                    </div>
                </div>
                : null
        }
        {
            props.floorplan ?
                <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                    <br />
                    <Input
                        type="checkbox"
                        checked={assignSpot}
                        onChange={e => {
                            if (assignSpot) {
                                setBid(false)
                            }
                            setAssignSpot(!assignSpot)
                            setQuantity(spots.length)
                        }}
                        style={{ height: 'auto' }}
                    />
                    <span style={{ paddingLeft: '5px' }}>
                        Map to Seating Layout
                    </span>
                </div> : null
        }
        {
            props.floorplan && assignSpot ?
                <div style={{ paddingLeft: '20px', width: '100%', textAlign: 'left' }}>
                    <br />
                    <Input
                        type="checkbox"
                        checked={bid}
                        onChange={e => {
                            if (!bid) {
                                const updatedEndTime = new Date(startTime.getTime())
                                updatedEndTime.setDate(updatedEndTime.getDate() + 7)
                                setEndTime(updatedEndTime)
                            }
                            setBid(!bid)
                        }}
                        style={{ height: 'auto' }}
                        disabled={!hasOwnerSetupPayments}
                    />
                    <span style={{ paddingLeft: '5px' }}>
                        Bidding
                    </span>
                </div> : null
        }
        {
            props.floorplan && assignSpot ?
                <Info style={{ paddingLeft: '20px' }}>
                    Maximum bid period duration is 7 days. You cannot modify this period once a bid is placed.
                </Info> : null
        }
        {
            props.floorplan && assignSpot ?
                <div style={{ position: 'relative', marginTop: '10px', marginBottom: props.fpBackground ? imageHeight + 25 : height * 26 }}>
                    <div style={{ position: 'absolute' }}>
                        {
                            props.fpBackground ?
                                <img src={props.fpBackground}
                                    onLoad={e => onImgLoad(e)}
                                    style={{ width: '100%', opacity: 0.75, zIndex: 30, borderRadius: '10px' }} /> : null
                        }
                    </div>
                    <div style={{ position: 'absolute', height: props.fpBackground ? imageHeight : height * 25, width: '100%', opacity: 1, zIndex: 35 }}>
                        <ResponsiveScatterPlot
                            data={data}
                            margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                            enableGridX={false}
                            enableGridY={false}
                            // blendMode="darken"
                            axisTop={null}
                            axisRight={null}
                            axisLeft={null}
                            axisBottom={null}
                            onClick={(n, e) => nodeOnClick(n, e)}
                            colors={{ scheme: 'paired' }}
                            renderNode={CustomNode}
                            tooltip={({ node }: any) => (
                                <div
                                    className='blur-safari'
                                    style={{
                                        padding: '10px',
                                        color: '#242d51',
                                        borderRadius: '15px',
                                        backdropFilter: 'blur(20px)',
                                        border: '0.4px solid #f1f1f1',
                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02), 0 1px 3px rgba(0, 0, 0, 0.02)'
                                    }}
                                >
                                    <strong>
                                        {node.data.serieId}
                                    </strong>
                                </div>
                            )}
                        />
                    </div>
                </div> : null
        }
        {
            props.inventory.length > 0 ?
                <div>
                    <br />
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <span className='sexyBlack'>
                            Start Selling After
                            <br />
                        </span>
                        <span>
                            <UncontrolledDropdown style={{ paddingLeft: '10px' }}>
                                <DropdownToggle
                                    caret={true}
                                    className='new-button-cancel'
                                    data-toggle="dropdown"
                                    tag='button'
                                >
                                    {sellAfter === '' ? '-' : selectedName}
                                </DropdownToggle>
                                <DropdownMenu style={{ borderRadius: '10px' }}>
                                    <DropdownItem onClick={() => setSellAfter('')}>
                                        -
                                    </DropdownItem>
                                    {
                                        props.inventory.map((item) => {
                                            return <DropdownItem onClick={() => {
                                                setSellAfter(item.id)
                                                setSelectedName(item.name)
                                            }} key={item.id}>
                                                {item.name}{' $' + (item.price / 100).toFixed(2)}
                                            </DropdownItem>
                                        })
                                    }
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </span>
                    </div>
                </div> : null
        }
        {
            options.length !== 0 && (!props.email || props.email === '') ?
                <div style={{ marginTop: 25, marginBottom: 25 }}>
                    <Label>
                        Allocate to
                    </Label>
                    <MultiSelect
                        options={options}
                        selected={selected}
                        onSelectedChanged={(s: any) => setSelected(s)}
                    />
                </div> : null
        }
        {
            error ?
                <div style={{ padding: '20px' }}>
                    <Error content={errorMessage} />
                </div>
                : null
        }
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '25px' }}>
            <button
                disabled={btnDisabled}
                role="submit"
                type="submit"
                className="new-button-save"
                onClick={e => handleCreateInventory()}
            >
                {createBtnText}
            </button>
        </div>
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
            <button className='new-button-cancel' onClick={() => closeModal()}>
                CANCEL
            </button>
        </div>
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(CreateInventoryModal);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/CreateInventory.modal.tsx